export default __webpack_public_path__ + "beta-maps-guides-migrate-basic-map-1200-7ef9e89df681985e0ce3039f86b45d27.png";